import queries from '@apis/queries';
import { GetOrderLogsParams, OrderLogRow } from '@models/order/orderLog';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

const DATE_FORMAT = 'YYYY-MM-DD';

function useOrderLogs(duration: 'WEEK'| 'ONE_MONTH' | 'THREE_MONTH' | 'ALL') {
  const to = dayjs().format(DATE_FORMAT);
  const from = (() => {
    switch (duration) {
      case 'WEEK':
        return dayjs().subtract(1, 'week').format(DATE_FORMAT);
      case 'ONE_MONTH':
        return dayjs().subtract(1, 'month').format(DATE_FORMAT);
      case 'THREE_MONTH':
        return dayjs().subtract(3, 'month').format(DATE_FORMAT);
      default:
        return dayjs().subtract(6, 'month').format(DATE_FORMAT);
    }
  })();
  const [page, setPage] = useState<number>(0);
  const params: GetOrderLogsParams = {
    page,
    size: 5,
    from,
    to,
  };
  const [orderLogs, setOrderLogs] = useState<OrderLogRow[]>([]);
  const { data, status } = useQuery(queries.orderLog.list(params));
  const isEmpty = data?.slice.empty;
  const fetchNext = () => {
    if (status === 'success' && !data?.slice.last) {
      setPage(((prev) => prev + 1));
    }
  };
  // 조회 기준 변경 시 페이지 초기화
  useEffect(() => {
    setPage(0);
  }, [duration]);
  useEffect(() => {
    if (data) {
      if (data.slice.first) {
        setOrderLogs(data.content);
      } else {
        setOrderLogs((prev) => [...prev, ...data.content]);
      }
    }
  }, [data]);
  return {
    fetchNext,
    orderLogs,
    status,
    isEmpty,
  };
}

export default useOrderLogs;
